<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">数据中心</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">销售漏斗</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="data-statistics">
            <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="按所属人统计"></a-tab-pane>
                <a-tab-pane key="2" tab="按创建时间统计"></a-tab-pane>
            </a-tabs>

            <div class="top-search">
                <a-row type="flex">
                    <a-col><label for="">预计成交时间：</label></a-col>
                    <a-col>
                        <div class="select-date-custom">
                            <a-input class="search-date" v-model="time" @click="showdate">
                                <a-tooltip slot="suffix" title="Extra information">
                                    <div class="date-icon"></div>
                                </a-tooltip>
                            </a-input>
                            <span class="select-date-modal" v-if="dateshow">
                                <div class="date-modal">
                                    <div class="time-modal">
                                        <div class="time-system">
                                            <div class="select-item" @click="selectdate2(i,item)" :class="{clickdate:i==currentdate}" v-for="(item,i) in datelist2" :key="i">{{item}}</div>
                                        </div>
                                        <div class="time-custom">
                                            <span class="time-system-text">自定义</span>
                                            <div class="time-select-index-hide">
                                                <a-date-picker format="YYYY-MM-DD" @change="dateChange2"/>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </a-col>
                </a-row>

                <!-- <a-row  type="flex">
                    <a-col><label for="">部门：</label></a-col>
                    <a-col>
                        <a-select default-value="lucy" style="width: 120px" @change="handleChange">
                            <a-select-option value="jack">
                                Jack
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

                <a-row  type="flex">
                    <a-col><label for="">员工：</label></a-col>
                    <a-col>
                        <a-select default-value="1" style="width: 120px" @change="handleChange">
                            <a-select-option value="1">
                                呼入
                            </a-select-option>
                            <a-select-option value="2">
                                呼出
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row> -->
            </div>

            <div class="tj-charts">
                <div id="weightChart" style="width: 100%;height:394px;"></div>
            </div>

            
            <div class="table-content" style="margin:10px 0 0 0">
                <div class="table-top-info">
                    <a-button icon="upload">导出</a-button>
                    <div>商机：{{total.bussnessnum}}</div>
                    <div>预计成交金额：￥{{total.antipatemoney}}</div>
                    <div>概率金额：￥{{total.percentmoney}}</div>
                </div>

                <a-table :columns="columns" :data-source="data">
                    <a slot="name" slot-scope="text">{{ text }}</a>
                </a-table>
            </div>
        </div>
    </div>
</template>

<script>
const columns = [
  {
    title: '销售阶段',
    dataIndex: 'salestep',
    key: 'salestep',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '商机数',
    dataIndex: 'bussnessnum',
    key: 'bussnessnum',
  },
  {
    title: '预计成交金额',
    dataIndex: 'antipatemoney',
    key: 'antipatemoney',
    ellipsis: true,
  },
  {
    title: '概率金额',
    dataIndex: 'percentmoney',
    key: 'percentmoney',
    ellipsis: true,
  },
];


export default {
    data(){
        return{
            data:"",
            columns,
            lddata:"",
            total:"",

            datelist2:['今天','昨天','本周','上周','本月','上月'],
            currentdate:"",
            dateshow:false,
            time:"今天",
            chart1:'block',
            chart2:'none'
        }
    },
    mounted(){
         this.$axios.get('/api/salestatistic',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    date:this.time
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.lddata=res.data.data.list
                    this.data=res.data.data.list
                    this.total=res.data.data.statistic
                    this.drawLine()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        // this.ldtj()
    },
    methods:{

           // 日期选择
        handleChange(){

        },
        showdate(){
            this.dateshow=!this.dateshow
        },
        selectdate2(a,b){
            this.currentdate=a
            this.time=b
            this.dateshow=false
            this.ldtj()
        },
        dateChange2(data,dateString){
            console.log(dateString)
            this.time=dateString
            this.dateshow=false
            this.ldtj()
        },

        ldtj(){
                // 销售漏斗
            this.$axios.get('/api/salestatistic',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    date:this.time
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.lddata=res.data.data.list
                    this.data=res.data.data.list
                    this.total=res.data.data.statistic
                    this.drawLine()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        drawLine(){
            var weightChart = this.$echarts.init(document.getElementById("weightChart"))
             weightChart.setOption({
                color: ['#6688f9','#6688f9','#6688f9','#6688f9','#5fcaca','#c6cde5' ],

                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c}%"
                },
                grid: {  
                    top:'6%', 
                    bottom: '14%',  
                    containLabel: true  
                }, 
    
                series: [
                    {
                        name:'漏斗图',
                        type:'funnel',
                        left: '5%',
                        top: 60,
                        bottom: 60,
                        width: '80%',
                        min: 0,
                        max: 100,
                        minSize: '6%',
                        maxSize: '45%',
                        sort: 'descending',
                        gap: 2,
                       
                        emphasis: {
                            label: {
                                fontSize: 14,
                            }
                        },
                        data: [
                            {value: 90, name: '初步接洽'+this.lddata[0].bussnessnum,barHeight: 6},
                            {value: 75, name: '需求确定'+this.lddata[1].bussnessnum},
                            {value: 60, name: '方案/报价'+this.lddata[2].bussnessnum},
                            {value: 45, name: '谈判审核'+this.lddata[3].bussnessnum},
                            {value: 30, name: '赢单'+this.lddata[4].bussnessnum},
                            {value: 15, name: '输单'+this.lddata[5].bussnessnum},
                        ]
                    },

                    {
                        name:'漏斗图',
                        type:'funnel',
                        left: '5%',
                        top: 60,
                        bottom: 60,
                        width: '80%',
                        min: 0,
                        max: 100,
                        minSize: '6%',
                        maxSize: '45%',
                        label: {
                            position: 'inside',
                            formatter: '￥{b}',
                            color: '#fff'
                        },
                        itemStyle: {
                            opacity: 0.5,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        emphasis: {
                            label: {
                               formatter: '￥{b}' 
                            }
                        },
                        data: [

                            {value: 90, name: this.lddata[0].percentmoney,barHeight: 6},
                            {value: 75, name: this.lddata[1].percentmoney},
                            {value: 60, name: this.lddata[2].percentmoney},
                            {value: 45, name: this.lddata[3].percentmoney},
                            {value: 30, name: this.lddata[4].percentmoney},
                            {value: 15, name: this.lddata[5].percentmoney},
                        ],
                        // Ensure outer shape will not be over inner shape when hover.
                        z: 100
                    }
                ]
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/data/funnel.vue